import { Button, TextField } from '@material-ui/core';
import React, { useState } from 'react'
import styled from "styled-components";
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { consumeOrder } from '../../../../redux/api/orders';
import { ButtonBlue } from '../../../common/ButtonsGenerics';
import PageLoading from '../../../common/PageLoading';
import { SnackBarGeneric } from '../../../common/SnackBarGeneric';
import { Text } from '../../../common/Text';

const ConfirmOrder = (props) => {

    const { id, handleClose, handleCloseConfirm } = props

    const [code, setCode] = useState("")
    const [loading, setLoading] = useState(false);

    const [snackBar, closeSnackBar, openSnackBar] = useSnackBar();

    const handleChange = e => {
        setCode(e.target.value)
    }

    const handleSubmit = async () => {
        setLoading(true)
        const request = await consumeOrder(id, code)
        setLoading(false)
        if (request?.statusCode === 404) {
            openSnackBar(
                "error",
                "¡Código no válido!"
            );
            return
        }
        if (request.error) {
            openSnackBar(
                "error",
                "¡Error al consumir la orden!"
            );
            return
        }
        openSnackBar(
            "success",
            "¡Se consumio la orden correctamente!"
        );
        setTimeout(() => {
            handleCloseConfirm(id)
        }, 1500);
    }

    return (
        <ConfirmOrderWrapper>
            <Header>
                <Text color="#555555" fontSize="2rem" fontWeight="bold">Consumir orden</Text>
            </Header>
            <Body>
                <TextField value={code} onChange={handleChange} label="Ingresar código de validación" fullWidth />
            </Body>
            <Footer>
                <Button onClick={handleClose}>Cancelar</Button>
                {!loading ? <ButtonBlue disabled={code === "" ? true : false} onClick={handleSubmit}>Enviar</ButtonBlue> : <PageLoading h="50px" />}
            </Footer>
            <SnackBarGeneric
                show={snackBar.show}
                handleClose={closeSnackBar}
                message={snackBar.message}
                variant={snackBar.variant}
            />
        </ConfirmOrderWrapper>
    )
}

export default ConfirmOrder

const ConfirmOrderWrapper = styled.div`
    min-width: 350px;
    width: 100%;
`

const Footer = styled.div`
    padding: 10px;
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
`

const Header = styled.div`
    width: 100%;
    padding: 10px 0;
    border-bottom: 2px solid #aaaaaa;
`

const Body = styled.div`
    padding: 25px 0;
`